<template>
  <b-row>
    <b-col>
      <b-card>
        <div class="card-body">
          <b-row>
            <b-col>
              <label>{{ $t('views.automats.servicemanitemspicking.idUserData') }}:</label>
              <div class="form-group">
                <fg-input>
                  <el-select
                    class="select-default"
                    :placeholder="$t('views.automats.servicemanitemspicking.idUserData')"
                    filterable
                    v-model="document.idUserData">
                    <el-option v-for="option in userDataOptions"
                               class="select-default"
                               :value="option['@id']"
                               :label="option.name + ' ' + option.surname"
                               :key="option['@id']">
                    </el-option>
                  </el-select>
                </fg-input>
              </div>
            </b-col>
          </b-row>
          <template v-for="(position, positionIndex) in document.positions">
            <Position v-bind:key="'position-' + positionIndex"
                      :exsbItemsOptions="exsbItemsOptions"
                      :exsbWarehousesOptions="exsbWarehousesOptions"
                      :item="position" :index="positionIndex"
                      :deletePosition="removePosition"></Position>
          </template>
          <b-row>
            <b-col>
              <b-btn @click="addNewPostion()">{{$t('views.automats.servicemanitemspicking.addnewposition')}}</b-btn>
              <b-btn v-if="document.positions.length > 0" @click="createNewDocument()" variant="success">{{ $t('buttons.submit') }}</b-btn>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import ApiService from '@/utils/ApiService'
import Position from './Position'
import getId from '@/utils/getIdFromLink'
export default {
  name: 'ServicemanItemsPicking',

  components: {
    Position
  },

  data () {
    return {
      document: {
        idUserData: null,
        positions: []
      },
      exsbItemsOptions: [],
      exsbWarehousesOptions: [],
      userDataOptions: []
    }
  },

  created () {
    this.getWarehouses()
    this.getItems()
    this.getServicemen()
  },

  methods: {
    async createNewDocument () {
      let document = JSON.parse(JSON.stringify(this.document))
      if (document.idUserData) {
        document.idUserData = parseInt(this.getIdLink(document.idUserData))
      }
      for (let i in document.positions) {
        if (document.positions[i].idExsbItem) {
          document.positions[i].idExsbItem = parseInt(this.getIdLink(document.positions[i].idExsbItem))
        }
        if (document.positions[i].idExsbWarehouse) {
          document.positions[i].idExsbWarehouse = parseInt(this.getIdLink(document.positions[i].idExsbWarehouse))
        }
        if (document.positions[i].quantity) {
          document.positions[i].quantity = parseInt(document.positions[i].quantity)
        }
      }
      const response = await new ApiService('e_x_s_b_documents/pick').post(document)
      if (response.status < 300) {
        let newDocument = await response.json()
        this.$router.push({ name: 'EXSBDocumentShow', params: { id: newDocument['@id'] } })
      }
    },

    async getServicemen () {
      let params = {
        'pagination': false,
        'isCompany': 0,
        'state': 1,
        'idClientType': 5
      }
      this.userDataOptions = []
      const response = await new ApiService('user_datas', params).getResults()
      this.userDataOptions = response.items
    },

    async getWarehouses () {
      let params = {
        'pagination': false,
        'forUserData': 0
      }
      this.exsbWarehousesOptions = []
      const response = await new ApiService('e_x_s_b_warehouses', params).getResults()
      this.exsbWarehousesOptions = response.items
    },

    async getItems () {
      let params = {
        'pagination': false
      }
      this.exsbItemsOptions = []
      const response = await new ApiService('e_x_s_b_items', params).getResults()
      this.exsbItemsOptions = response.items
    },

    removePosition (index) {
      this.document.positions.splice(index, 1)
    },

    addNewPostion () {
      let item = {
        idExsbItem: null,
        idExsbWarehouse: null,
        quantity: 1
      }
      this.document.positions.push(item)
    },

    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
